/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import {
    USER_PREF_VIDEO_WINDOW_SET_GHOST_MODE,
    USER_PREF_VIDEO_WINDOW_SET_SELECTED_OPTION,
} from './userprefvideowindow.types';

export const userPrefVideoWindowEnableGhostModeAction = (
    isGhostModeActive: boolean,
): TivoPayloadAction<{ isGhostModeActive: boolean }> => ({
    type: USER_PREF_VIDEO_WINDOW_SET_GHOST_MODE,
    payload: {
        isGhostModeActive,
    },
});

export const userPrefVideoWindowSetSelectedOptionAction = (
    selectedOption: number,
): TivoPayloadAction<{ selectedOption: number }> => ({
    type: USER_PREF_VIDEO_WINDOW_SET_SELECTED_OPTION,
    payload: {
        selectedOption,
    },
});
